export const CAMPAIGN_SCHEDULE = {
  GGU: {
    endDate: '2025-07-16 15:00:00',
    timeZone: 'Asia/Singapore',
  },
  HALLOWEEN: {
    startDate: '2025-10-14 16:00:00',
    endDate: '2025-11-03 16:00:00',
    timeZone: 'Asia/Singapore',
  },
  YEAR_END: {
    startDate: '2025-12-01 00:00:00',
    endDate: '2026-01-01 23:59:59',
    timeZone: 'Asia/Singapore',
  },
  SPRING_SALE: {
    startDate: '2026-03-18 16:00:00',
    endDate: '2026-03-25 16:00:00',
    timeZone: 'Asia/Singapore',
  },
};

// Top Ranked Section Categories Configuration
export const TOP_RANKED_CATEGORIES_CONFIG = {
  DEFAULT_MAX: 10,
  JANUARY_2026_MAX: 15,
  JANUARY_2026: {
    year: 2026,
    month: 0, // 0-indexed (January = 0)
  },
};

/**
 * Get the maximum number of categories to display in Top Ranked Section
 * Returns 15 during January 2026 (user's local timezone), otherwise 10
 */
export const getTopRankedMaxCategories = (): number => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  const { JANUARY_2026, DEFAULT_MAX, JANUARY_2026_MAX } = TOP_RANKED_CATEGORIES_CONFIG;

  if (year === JANUARY_2026.year && month === JANUARY_2026.month) {
    return JANUARY_2026_MAX;
  }

  return DEFAULT_MAX;
};
